import React from 'react';
import { useTranslation } from 'react-i18next';
import { TargetIcon, TrendingUpIcon, UnlockIcon, HeartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Mission() {
  const {
    t
  } = useTranslation();
  const missionPoints = [{
    icon: TargetIcon,
    text: t('mission.point1'),
    gradientClass: 'bg-gradient-to-br from-teal-400 to-teal-600'
  }, {
    icon: TrendingUpIcon,
    text: t('mission.point2'),
    gradientClass: 'bg-gradient-to-br from-blue-400 to-blue-600'
  }, {
    icon: UnlockIcon,
    text: t('mission.point3'),
    gradientClass: 'bg-gradient-to-br from-indigo-400 to-indigo-600'
  }, {
    icon: HeartIcon,
    text: t('mission.point4'),
    gradientClass: 'bg-gradient-to-br from-purple-400 to-purple-600'
  }];
  return <section className="w-full py-32 px-6 bg-gradient-to-b from-slate-50 to-white" data-id="element-110">
      <div className="max-w-7xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-112">
          <h2 className="text-5xl md:text-6xl font-bold mb-4" data-id="element-113">
            <span className="text-gradient" data-id="element-114">{t('mission.title')}</span>
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 font-light" data-id="element-115">
            {t('mission.subtitle')}
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-116">
          {missionPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -8,
            scale: 1.02
          }} data-id="element-117">
                <div className="glass rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all h-full" data-id="element-118">
                  <div className="flex items-start gap-5" data-id="element-119">
                    <div className={`flex-shrink-0 w-14 h-14 ${point.gradientClass} rounded-2xl flex items-center justify-center shadow-lg`} data-id="element-120">
                      <Icon className="w-7 h-7 text-white" data-id="element-121" />
                    </div>
                    <p className="text-slate-700 leading-relaxed flex-1 text-lg" data-id="element-122">
                      {point.text}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-123">
          <div className="inline-block glass rounded-full px-10 py-5 shadow-xl" data-id="element-124">
            <p className="text-xl font-semibold text-gradient" data-id="element-125">
              {t('mission.commitment')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}